import React from 'react';
import PropTypes from 'prop-types';

const GroupFilterButton = ({ active, children, onClick, hide, loading }) => {
  if (hide) {
    return null;
  }

  if (active) {
    return (
      <button className="btn btn__toggle btn__toggle--active">
        {children}
      </button>
    );
  }

  return (
    <button
      className="btn btn__toggle"
      disabled={loading}
      href="#"
      onClick={e => {
        e.preventDefault();
        onClick();
      }}
    >
      {children}
    </button>
  );
};

GroupFilterButton.propTypes = {
  active: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired
};

export default GroupFilterButton;



// WEBPACK FOOTER //
// ./src/components/GroupFilterButton.js